'use strict';
import angular from 'angular';
import './scripts/product.categories.ctrls';
import './scripts/product.categories.services';

import categoriesHtmlUrl from './views/categories.html';

angular.module('productCategories', ['product.categories.ctrls', 'product.categories.services'])

    .config(['$stateProvider', function ($stateProvider) {

        $stateProvider
            .state('productCategories', {
                parent: 'layout',
                url: '/admin/products/categories',
                templateUrl: categoriesHtmlUrl,
                controller: 'ProductCategoryController'
            })
    }]);